export default "__VITE_ASSET__14ccc73e__"